import Vue from 'vue';
import App from './app';
import store from './store';
import VueSweetalert2 from 'vue-sweetalert2';
import vuetify from './plugins/vuetify';
import router from './router';
import i18n from './utils/localization/i18n';
import Toast from "vue-toastification";
import '/src/styles/styles.css';
import './utils/constants'
import "vue-toastification/dist/index.css";
import Antd from 'ant-design-vue';  
import '@/assets/antd.css';
import Chart from 'chart.js/auto'
import * as Sentry from '@sentry/vue'


Vue.use(Antd);
const options = {
  transition: "Vue-Toastification__bounce",
  position: "top-center",
  timeout: 3000,
  closeButton: "button",
  icon: true,
  toastDefaults: {
    success: {
      style: { background: "#4CAF50", color: "#fff" } 
    },
    error: {
      style: { background: "#F44336", color: "#fff" } 
    },
    info: {
      style: { background: "#2196F3", color: "#fff" }
    },
    warning: {
      style: { background: "#FFC107", color: "#000" } 
    }
  }
};
Vue.prototype.$ChartJS = Chart
Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
// Vue.config.devtools = false;
Vue.use(Toast, options);
Vue.prototype.$sentry = Sentry

new Vue({
  router,
  store,
  vuetify,
  i18n,
  provide: {
    baseURL: Vue.prototype.$baseURL,
  },
  render: (h) => h(App),
}).$mount('#app');
